import React, {
  useCallback,
  useEffect,
  useState
} from 'react'

import axios from 'axios'
import { useSelector } from 'react-redux'
import Navbar from './Navbar'




export default function PhysicalVerification() {

  const { url } = useSelector(
    state => state
  )

  const [applications, setApplications] =
    useState([])

  const [
    selectedApplication,
    setSelectedApplication
  ] = useState(null)

  const [photoCategory, setPhotoCategory] =
  useState('')

const [photoFile, setPhotoFile] =
  useState(null)

const [photoCaption, setPhotoCaption] =
  useState('')

const [uploadingPhoto, setUploadingPhoto] =
  useState(false)

  const [loading, setLoading] =
    useState(true)

  const [opening, setOpening] =
    useState(false)

  const [saving, setSaving] =
    useState(false)

  const [error, setError] =
    useState('')

  const [success, setSuccess] =
    useState('')


  const [tenantChecklist, setTenantChecklist] =
    useState({})

  const [
    landlordChecklist,
    setLandlordChecklist
  ] = useState({})

  const [
    propertyChecklist,
    setPropertyChecklist
  ] = useState({})

  const [notes, setNotes] =
    useState('')


const getHeaders = useCallback(() => ({
  Authorization:
    `Bearer ${localStorage.getItem(
      'access_token'
    )}`
}), [])


  const formatCurrency = amount => {

    return `₦${Number(
      amount || 0
    ).toLocaleString()}`
  }


  const formatDate = date => {

    if (!date) {
      return '—'
    }

    return new Date(
      date
    ).toLocaleString(
      'en-GB',
      {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      }
    )
  }


const fetchApplications = useCallback(async () => {

  const response =
    await axios.get(
      `${url}/admin/physical-verifications`,
      {
        headers: getHeaders()
      }
    )

  const results =
    response.data.applications || []

  setApplications(results)

  return results

}, [url, getHeaders])

useEffect(() => {

  const load = async () => {

    try {

      setLoading(true)
      setError('')

      await fetchApplications()

    } catch (err) {

      console.error(err)

      setError(
        err.response?.data?.detail ||
        'Unable to load physical verifications.'
      )

    } finally {

      setLoading(false)
    }
  }

  load()

}, [fetchApplications])


  const hydrateForm = application => {

    const verification =
      application.verification

    setTenantChecklist(
      verification?.tenant_checklist || {}
    )

    setLandlordChecklist(
      verification?.landlord_checklist || {}
    )

    setPropertyChecklist(
      verification?.property_checklist || {}
    )

    setNotes(
      verification?.notes || ''
    )
  }


  const openApplication = async application => {

    try {

      setOpening(true)
      setError('')
      setSuccess('')

      let currentApplication =
        application


      /*
       * If physical verification has never
       * been started, create the backend
       * verification record first.
       */

      if (!application.verification) {

        await axios.post(
          `${url}/admin/loan-applications/${application.loan_application_id}/physical-verification/start`,
          {},
          {
            headers: getHeaders()
          }
        )

        const refreshed =
          await fetchApplications()

        currentApplication =
          refreshed.find(
            item =>
              item.loan_application_id ===
              application.loan_application_id
          )

        if (!currentApplication) {

          throw new Error(
            'Unable to reload verification.'
          )
        }
      }


      setSelectedApplication(
        currentApplication
      )

      hydrateForm(
        currentApplication
      )

    } catch (err) {

      console.error(err)

      setError(
        err.response?.data?.detail ||
        err.message ||
        'Unable to start physical verification.'
      )

    } finally {

      setOpening(false)
    }
  }


  const closeApplication = () => {

    setSelectedApplication(null)

    setTenantChecklist({})
    setLandlordChecklist({})
    setPropertyChecklist({})

    setNotes('')
    setSuccess('')
  }


  const updateChecklist = (
    setter,
    key,
    value
  ) => {

    setter(previous => ({

      ...previous,

      [key]:
        value === ''
          ? null
          : value === 'true'
    }))
  }


  const saveVerification = async () => {

    if (!selectedApplication) {
      return
    }

    try {

      setSaving(true)
      setError('')
      setSuccess('')


      const response = await axios.patch(
        `${url}/admin/loan-applications/${selectedApplication.loan_application_id}/physical-verification`,
        {
          tenant_checklist:
            tenantChecklist,

          landlord_checklist:
            landlordChecklist,

          property_checklist:
            propertyChecklist,

          notes
        },
        {
          headers: getHeaders()
        }
      )

      if (
        response.data.application_status ===
        'awaiting_disbursement'
      ) {

        setSuccess(
          'Physical verification passed. The application is now awaiting disbursement.'
        )

        setSelectedApplication(null)

        await fetchApplications()

        return
      }


      const refreshed =
        await fetchApplications()

      const updatedApplication =
        refreshed.find(
          item =>
            item.loan_application_id ===
            selectedApplication.loan_application_id
        )


      if (updatedApplication) {

        setSelectedApplication(
          updatedApplication
        )

        hydrateForm(
          updatedApplication
        )
      }


      setSuccess(
        'Physical verification saved successfully.'
      )

    } catch (err) {

      console.error(err)

      setError(
        err.response?.data?.detail ||
        'Unable to save physical verification.'
      )

    } finally {

      setSaving(false)
    }
  }


  const uploadVerificationPhoto = async () => {

  if (
    !selectedApplication ||
    !photoCategory ||
    !photoFile
  ) {

    setError(
      'Choose a photo category and image.'
    )

    return
  }

  try {

    setUploadingPhoto(true)
    setError('')
    setSuccess('')

    const formData = new FormData()

    formData.append(
      'category',
      photoCategory
    )

    formData.append(
      'image',
      photoFile
    )

    if (photoCaption.trim()) {

      formData.append(
        'caption',
        photoCaption.trim()
      )
    }


    await axios.post(
      `${url}/admin/loan-applications/${selectedApplication.loan_application_id}/physical-verification/photos`,
      formData,
      {
        headers: getHeaders()
      }
    )


    const refreshed =
      await fetchApplications()

    const updated =
      refreshed.find(
        item =>
          item.loan_application_id ===
          selectedApplication.loan_application_id
      )

    if (updated) {

      setSelectedApplication(updated)
      hydrateForm(updated)
    }


    setPhotoCategory('')
    setPhotoFile(null)
    setPhotoCaption('')

    setSuccess(
      'Verification photo uploaded.'
    )

  } catch (err) {

    console.error(err)

    setError(
      err.response?.data?.detail ||
      'Unable to upload photo.'
    )

  } finally {

    setUploadingPhoto(false)
  }
}


  return (

    <div className="
      flex
      min-h-screen
      bg-gray-50
      font-[Satoshi]
    ">

      <Navbar />


      <main className="
        flex-1
        min-w-0
        p-6
        lg:p-8
      ">


        {/* PAGE HEADER */}

        <div className="mb-8">

          <h1 className="
            text-2xl
            font-bold
            text-gray-900
          ">
            Physical Verification
          </h1>

          <p className="
            text-gray-500
            mt-1
          ">
            Verify the tenant, landlord and
            rental property before disbursement.
          </p>

        </div>


        {error && (

          <div className="
            mb-6
            bg-red-50
            border
            border-red-100
            text-red-600
            rounded-lg
            p-4
          ">
            {error}
          </div>

        )}


        {success && (

          <div className="
            mb-6
            bg-green-50
            border
            border-green-100
            text-green-700
            rounded-lg
            p-4
          ">
            {success}
          </div>

        )}


        {loading ? (

          <p className="text-gray-400">
            Loading physical verifications...
          </p>

        ) : applications.length === 0 ? (

          <div className="
            bg-white
            border
            border-dashed
            border-gray-300
            rounded-xl
            p-14
            text-center
          ">

            <p className="
              text-gray-400
              font-semibold
            ">
              No applications are awaiting
              physical verification.
            </p>

          </div>

        ) : (

          <div className="
            grid
            grid-cols-1
            xl:grid-cols-2
            gap-5
          ">

            {applications.map(
              application => (

                <ApplicationCard
                  key={
                    application
                      .loan_application_id
                  }

                  application={
                    application
                  }

                  formatCurrency={
                    formatCurrency
                  }

                  onOpen={
                    openApplication
                  }

                  opening={
                    opening
                  }
                />

              )
            )}

          </div>

        )}


        {/* VERIFICATION MODAL */}

        {selectedApplication && (

        <div
          className="
            fixed
            inset-0
            z-[100]
            bg-black/50
            p-4
            flex
            justify-center
            items-start
          "
        >

          <div
            className="
              bg-white
              w-full
              max-w-5xl
              rounded-2xl
              shadow-xl
            "
            style={{
              maxHeight: 'calc(100vh - 2rem)',
              overflowY: 'auto'
            }}
          >


              {/* MODAL HEADER */}

              <div className="
                shrink-0
                border-b
                border-gray-200
                px-6
                py-5
                flex
                items-start
                justify-between
                gap-4
              ">

                <div>

                  <p className="
                    text-xs
                    font-bold
                    uppercase
                    tracking-wide
                    text-green-600
                  ">
                    Loan #
                    {
                      selectedApplication
                        .loan_application_id
                    }
                  </p>

                  <h2 className="
                    text-xl
                    font-bold
                    text-gray-900
                    mt-1
                  ">
                    {
                      selectedApplication
                        .fullname ||
                      selectedApplication
                        .email
                    }
                  </h2>

                  <p className="
                    text-sm
                    text-gray-500
                    mt-1
                  ">
                    Physical verification
                  </p>

                </div>


                <button
                  type="button"
                  onClick={
                    closeApplication
                  }
                  className="
                    text-gray-400
                    hover:text-gray-700
                    text-2xl
                    leading-none
                  "
                >
                  ×
                </button>

              </div>


              {/* SCROLL AREA */}

              <div className="
                px-6
                py-6
                space-y-7
              ">


                {/* APPLICATION DETAILS */}

                <section>

                  <SectionTitle>
                    Application details
                  </SectionTitle>

                  <div className="
                    grid
                    grid-cols-1
                    md:grid-cols-2
                    gap-4
                  ">

                    <DetailBox
                      label="Customer"
                      value={
                        selectedApplication
                          .fullname ||
                        selectedApplication
                          .email
                      }
                    />

                    <DetailBox
                      label="Rent amount"
                      value={
                        formatCurrency(
                          selectedApplication
                            .rent_amount
                        )
                      }
                    />

                    <DetailBox
                      label="Customer address"
                      value={
                        selectedApplication
                          .customer_address
                      }
                    />

                    <DetailBox
                      label="Rental property"
                      value={
                        selectedApplication
                          .property_address
                      }
                    />

                    <DetailBox
                      label="Landlord address"
                      value={
                        selectedApplication
                          .landlord_address
                      }
                    />

                    <DetailBox
                      label="Landlord phone"
                      value={
                        selectedApplication
                          .landlord_phone_number
                      }
                    />

                    <DetailBox
                      label="Landlord"
                      value={
                        selectedApplication
                          .landlord_account_name
                      }
                    />

                    <DetailBox
                      label="Landlord account"
                      value={
                        selectedApplication
                          .landlord_account_number
                      }
                    />

                  </div>

                </section>
                <div className="
  grid
  grid-cols-2
  md:grid-cols-3
  gap-4
">

  {
    selectedApplication
      .verification
      ?.photos
      ?.map(photo => (

        <div
          key={photo.id}
          className="
            border
            border-gray-200
            rounded-lg
            overflow-hidden
          "
        >

          <img
            src={photo.image_url}
            alt={photo.category}
            className="
              w-full
              h-36
              object-cover
            "
          />

          <div className="p-3">

            <p className="
              text-xs
              font-semibold
              text-gray-700
              break-words
            ">
              {
                photo.category
                  .replaceAll('_', ' ')
              }
            </p>

            {photo.caption && (

              <p className="
                text-xs
                text-gray-400
                mt-1
              ">
                {photo.caption}
              </p>

            )}

          </div>

        </div>

      ))
  }

</div>

                {/* VERIFICATION PHOTOS */}
                <section>

  <SectionTitle>
    Verification photos
  </SectionTitle>

  <div className="
    border
    border-gray-200
    rounded-xl
    p-5
    space-y-4
  ">

    <select
      value={photoCategory}
      onChange={e =>
        setPhotoCategory(
          e.target.value
        )
      }
      className="
        w-full
        border
        border-gray-300
        rounded-lg
        px-3
        py-2.5
        bg-white
      "
    >

      <option value="">
        Select photo type
      </option>

      <option value="tenant_residence_exterior">
        Tenant residence exterior
      </option>

      <option value="tenant_residence_interior">
        Tenant residence interior
      </option>

      <option value="landlord_residence_exterior">
        Landlord residence exterior
      </option>

      <option value="landlord_identity_confirmation">
        Landlord identity confirmation
      </option>

      <option value="rental_property_exterior">
        Rental property exterior
      </option>

      <option value="rental_property_entrance">
        Rental property entrance
      </option>

      <option value="other">
        Other
      </option>

    </select>


    <input
      type="file"
      accept="image/jpeg,image/png,image/webp"
      onChange={e =>
        setPhotoFile(
          e.target.files?.[0] || null
        )
      }
    />


    <input
      type="text"
      value={photoCaption}
      onChange={e =>
        setPhotoCaption(
          e.target.value
        )
      }
      placeholder="Optional caption"
      className="
        w-full
        border
        border-gray-300
        rounded-lg
        px-3
        py-2.5
      "
    />


    <button
      type="button"
      disabled={
        uploadingPhoto ||
        !photoCategory ||
        !photoFile
      }
      onClick={
        uploadVerificationPhoto
      }
      className="
        bg-gray-900
        hover:bg-black
        disabled:bg-gray-300
        text-white
        px-5
        py-2.5
        rounded-lg
        font-bold
        text-sm
      "
    >

      {
        uploadingPhoto
          ? 'Uploading...'
          : 'Upload photo'
      }

    </button>

  </div>

</section>


                {/* STATUS SUMMARY */}

                <section>

                  <SectionTitle>
                    Verification progress
                  </SectionTitle>

                  <div className="
                    grid
                    grid-cols-1
                    sm:grid-cols-2
                    lg:grid-cols-4
                    gap-3
                  ">

                    <StatusBox
                      label="Tenant"
                      status={
                        selectedApplication
                          .verification
                          ?.tenant_status
                      }
                    />

                    <StatusBox
                      label="Landlord"
                      status={
                        selectedApplication
                          .verification
                          ?.landlord_status
                      }
                    />

                    <StatusBox
                      label="Property"
                      status={
                        selectedApplication
                          .verification
                          ?.property_status
                      }
                    />

                    <StatusBox
                      label="Overall"
                      status={
                        selectedApplication
                          .verification
                          ?.overall_status
                      }
                    />

                  </div>

                </section>


                {/* TENANT */}

                <VerificationSection
                  title="Tenant verification"
                  status={
                    selectedApplication
                      .verification
                      ?.tenant_status
                  }
                >

                  <CheckItem
                    label="Tenant met in person"
                    value={
                      tenantChecklist
                        .tenant_met_in_person
                    }
                    onChange={value =>
                      updateChecklist(
                        setTenantChecklist,
                        'tenant_met_in_person',
                        value
                      )
                    }
                  />

                  <CheckItem
                    label="Residential address exists"
                    value={
                      tenantChecklist
                        .residential_address_exists
                    }
                    onChange={value =>
                      updateChecklist(
                        setTenantChecklist,
                        'residential_address_exists',
                        value
                      )
                    }
                  />

                  <CheckItem
                    label="Residential address matches application"
                    value={
                      tenantChecklist
                        .residential_address_matches_application
                    }
                    onChange={value =>
                      updateChecklist(
                        setTenantChecklist,
                        'residential_address_matches_application',
                        value
                      )
                    }
                  />

                  <CheckItem
                    label="Tenant resides at the address"
                    value={
                      tenantChecklist
                        .tenant_resides_at_address
                    }
                    onChange={value =>
                      updateChecklist(
                        setTenantChecklist,
                        'tenant_resides_at_address',
                        value
                      )
                    }
                  />

                  <CheckItem
                    label="Tenant identity matches application"
                    value={
                      tenantChecklist
                        .tenant_identity_matches_application
                    }
                    onChange={value =>
                      updateChecklist(
                        setTenantChecklist,
                        'tenant_identity_matches_application',
                        value
                      )
                    }
                  />

                </VerificationSection>


                {/* LANDLORD */}

                <VerificationSection
                  title="Landlord verification"
                  status={
                    selectedApplication
                      .verification
                      ?.landlord_status
                  }
                >

                  <CheckItem
                    label="Landlord met in person"
                    value={
                      landlordChecklist
                        .landlord_met_in_person
                    }
                    onChange={value =>
                      updateChecklist(
                        setLandlordChecklist,
                        'landlord_met_in_person',
                        value
                      )
                    }
                  />

                  <CheckItem
                    label="Landlord name matches application"
                    value={
                      landlordChecklist
                        .landlord_name_matches_application
                    }
                    onChange={value =>
                      updateChecklist(
                        setLandlordChecklist,
                        'landlord_name_matches_application',
                        value
                      )
                    }
                  />

                  <CheckItem
                    label="Landlord phone matches application"
                    value={
                      landlordChecklist
                        .landlord_phone_matches_application
                    }
                    onChange={value =>
                      updateChecklist(
                        setLandlordChecklist,
                        'landlord_phone_matches_application',
                        value
                      )
                    }
                  />

                  <CheckItem
                    label="Landlord address matches application"
                    value={
                      landlordChecklist
                        .landlord_address_matches_application
                    }
                    onChange={value =>
                      updateChecklist(
                        setLandlordChecklist,
                        'landlord_address_matches_application',
                        value
                      )
                    }
                  />

                  <CheckItem
                    label="Landlord confirms property"
                    value={
                      landlordChecklist
                        .landlord_confirms_property
                    }
                    onChange={value =>
                      updateChecklist(
                        setLandlordChecklist,
                        'landlord_confirms_property',
                        value
                      )
                    }
                  />

                  <CheckItem
                    label="Landlord confirms rent amount"
                    value={
                      landlordChecklist
                        .landlord_confirms_rent_amount
                    }
                    onChange={value =>
                      updateChecklist(
                        setLandlordChecklist,
                        'landlord_confirms_rent_amount',
                        value
                      )
                    }
                  />

                  <CheckItem
                    label="Landlord confirms bank details"
                    value={
                      landlordChecklist
                        .landlord_confirms_bank_details
                    }
                    onChange={value =>
                      updateChecklist(
                        setLandlordChecklist,
                        'landlord_confirms_bank_details',
                        value
                      )
                    }
                  />

                </VerificationSection>


                {/* PROPERTY */}

                <VerificationSection
                  title="Rental property verification"
                  status={
                    selectedApplication
                      .verification
                      ?.property_status
                  }
                >

                  <CheckItem
                    label="Property exists"
                    value={
                      propertyChecklist
                        .property_exists
                    }
                    onChange={value =>
                      updateChecklist(
                        setPropertyChecklist,
                        'property_exists',
                        value
                      )
                    }
                  />

                  <CheckItem
                    label="Property address matches application"
                    value={
                      propertyChecklist
                        .property_address_matches_application
                    }
                    onChange={value =>
                      updateChecklist(
                        setPropertyChecklist,
                        'property_address_matches_application',
                        value
                      )
                    }
                  />

                  <CheckItem
                    label="Property matches description"
                    value={
                      propertyChecklist
                        .property_matches_description
                    }
                    onChange={value =>
                      updateChecklist(
                        setPropertyChecklist,
                        'property_matches_description',
                        value
                      )
                    }
                  />

                  <CheckItem
                    label="Landlord confirms ownership or authority"
                    value={
                      propertyChecklist
                        .landlord_confirms_ownership_or_authority
                    }
                    onChange={value =>
                      updateChecklist(
                        setPropertyChecklist,
                        'landlord_confirms_ownership_or_authority',
                        value
                      )
                    }
                  />

                  <CheckItem
                    label="Tenant will occupy or already occupies property"
                    value={
                      propertyChecklist
                        .tenant_will_occupy_or_already_occupies
                    }
                    onChange={value =>
                      updateChecklist(
                        setPropertyChecklist,
                        'tenant_will_occupy_or_already_occupies',
                        value
                      )
                    }
                  />

                </VerificationSection>


                {/* NOTES */}

                <section>

                  <SectionTitle>
                    Internal notes
                  </SectionTitle>

                  <textarea
                    value={notes}
                    onChange={e =>
                      setNotes(
                        e.target.value
                      )
                    }
                    rows="5"
                    placeholder="Add verification notes..."
                    className="
                      w-full
                      border
                      border-gray-300
                      rounded-xl
                      p-4
                      text-sm
                      outline-none
                      focus:border-green-500
                    "
                  />

                  <p className="
                    text-xs
                    text-gray-400
                    mt-2
                  ">
                    Internal only. Do not include
                    unnecessary sensitive personal
                    information.
                  </p>

                </section>


                <div className="
                  text-xs
                  text-gray-400
                  pb-2
                ">

                  Verification started:{' '}

                  {formatDate(
                    selectedApplication
                      .verification
                      ?.verification_started_at
                  )}

                </div>

              </div>


              {/* FOOTER */}

              <div className="
                shrink-0
                border-t
                border-gray-200
                bg-gray-50
                px-6
                py-4
                flex
                flex-col
                sm:flex-row
                sm:items-center
                sm:justify-between
                gap-3
              ">

                <p className="
                  text-sm
                  text-gray-500
                ">
                  Saving does not disburse the loan.
                </p>


                <div className="
                  flex
                  gap-3
                ">

                  <button
                    type="button"
                    onClick={
                      closeApplication
                    }
                    className="
                      px-5
                      py-2.5
                      border
                      border-gray-300
                      rounded-lg
                      text-sm
                      font-semibold
                      text-gray-700
                      bg-white
                    "
                  >
                    Close
                  </button>


                  <button
                    type="button"
                    disabled={saving}
                    onClick={
                      saveVerification
                    }
                    className="
                      px-5
                      py-2.5
                      bg-green-600
                      hover:bg-green-700
                      disabled:bg-gray-300
                      text-white
                      rounded-lg
                      text-sm
                      font-bold
                    "
                  >
                    {
                      saving
                        ? 'Saving...'
                        : 'Save verification'
                    }
                  </button>

                </div>

              </div>

            </div>

          </div>

        )}

      </main>

    </div>

  )
}



function ApplicationCard({
  application,
  formatCurrency,
  onOpen,
  opening
}) {

  const status =
    application.verification
      ?.overall_status ||
    'not_started'

  return (

    <div className="
      bg-white
      border
      border-gray-200
      rounded-xl
      shadow-sm
      p-6
    ">

      <div className="
        flex
        justify-between
        items-start
        gap-4
      ">

        <div>

          <p className="
            font-bold
            text-gray-900
          ">
            {
              application.fullname ||
              application.email
            }
          </p>

          <p className="
            text-xs
            text-gray-400
            mt-1
          ">
            Loan #
            {application.loan_application_id}
          </p>

        </div>


        <StatusBadge
          status={status}
        />

      </div>


      <div className="
        mt-5
        space-y-3
        text-sm
      ">

        <CardDetail
          label="Rent"
          value={
            formatCurrency(
              application.rent_amount
            )
          }
        />

        <CardDetail
          label="Property"
          value={
            application.property_address
          }
        />

        <CardDetail
          label="Landlord"
          value={
            application.landlord_account_name
          }
        />

      </div>


      <button
        type="button"
        disabled={opening}
        onClick={() =>
          onOpen(application)
        }
        className="
          w-full
          mt-6
          py-3
          rounded-lg
          bg-gray-900
          hover:bg-black
          disabled:bg-gray-300
          text-white
          font-bold
          text-sm
        "
      >

        {
          application.verification
            ? 'Continue verification'
            : 'Start verification'
        }

      </button>

    </div>
  )
}



function VerificationSection({
  title,
  status,
  children
}) {

  return (

    <section className="
      border
      border-gray-200
      rounded-xl
      overflow-hidden
    ">

      <div className="
        bg-gray-50
        px-5
        py-4
        flex
        justify-between
        items-center
        gap-3
      ">

        <h3 className="
          font-bold
          text-gray-900
        ">
          {title}
        </h3>

        <StatusBadge
          status={
            status || 'pending'
          }
        />

      </div>


      <div className="
        divide-y
        divide-gray-100
      ">
        {children}
      </div>

    </section>
  )
}



function CheckItem({
  label,
  value,
  onChange
}) {

  const selectValue =
    value === true
      ? 'true'
      : value === false
        ? 'false'
        : ''

  return (

    <div className="
      px-5
      py-4
      flex
      flex-col
      sm:flex-row
      sm:items-center
      sm:justify-between
      gap-3
    ">

      <p className="
        text-sm
        text-gray-700
      ">
        {label}
      </p>


      <select
        value={selectValue}
        onChange={e =>
          onChange(
            e.target.value
          )
        }
        className="
          border
          border-gray-300
          rounded-lg
          px-3
          py-2
          text-sm
          bg-white
          min-w-[150px]
          outline-none
        "
      >

        <option value="">
          Not checked
        </option>

        <option value="true">
          Confirmed
        </option>

        <option value="false">
          Failed
        </option>

      </select>

    </div>
  )
}



function StatusBox({
  label,
  status
}) {

  return (

    <div className="
      border
      border-gray-200
      rounded-lg
      p-4
      bg-white
    ">

      <p className="
        text-xs
        text-gray-400
      ">
        {label}
      </p>

      <div className="mt-2">

        <StatusBadge
          status={
            status || 'pending'
          }
        />

      </div>

    </div>
  )
}



function StatusBadge({
  status
}) {

  const styles = {

    passed:
      'bg-green-100 text-green-700',

    failed:
      'bg-red-100 text-red-700',

    in_progress:
      'bg-blue-100 text-blue-700',

    pending:
      'bg-yellow-100 text-yellow-700',

    not_started:
      'bg-gray-100 text-gray-600'

  }


  const labels = {

    passed:
      'Passed',

    failed:
      'Failed',

    in_progress:
      'In progress',

    pending:
      'Pending',

    not_started:
      'Not started'

  }


  return (

    <span className={`
      inline-flex
      px-3
      py-1
      rounded-full
      text-xs
      font-bold
      ${styles[status] ||
        styles.pending}
    `}>

      {
        labels[status] ||
        status
      }

    </span>
  )
}



function SectionTitle({
  children
}) {

  return (

    <h3 className="
      text-sm
      font-bold
      text-gray-900
      uppercase
      tracking-wide
      mb-4
    ">
      {children}
    </h3>
  )
}



function DetailBox({
  label,
  value
}) {

  return (

    <div className="
      bg-gray-50
      rounded-lg
      p-4
    ">

      <p className="
        text-xs
        text-gray-400
        mb-1
      ">
        {label}
      </p>

      <p className="
        text-sm
        font-semibold
        text-gray-800
        break-words
      ">
        {value || '—'}
      </p>

    </div>
  )
}



function CardDetail({
  label,
  value
}) {

  return (

    <div className="
      flex
      justify-between
      gap-4
    ">

      <span className="
        text-gray-400
      ">
        {label}
      </span>

      <span className="
        text-gray-800
        font-semibold
        text-right
      ">
        {value || '—'}
      </span>

    </div>
  )
}